import React from 'react';

import Parameters from 'shared/product_tabs/tab_assembly/components/Parameters';
import Prices from 'shared/product_tabs/tab_assembly/components/Prices';

const Assembly = () => (
  <div className="row quote-work-area tab-assembly">
    <div className="col-lg-5 col-xl-4 quoteform-background">
      <div className="parameters">
        <Parameters />
      </div>
    </div>
    <div className="col-lg-7 col-xl-8 px-0">
      <div className="pcb-price-section">
        <Prices />
      </div>
    </div>
  </div>
);

export default Assembly;
